import { Row } from 'antd';
import styled from 'styled-components';

export const PermissionsTitleRow = styled(Row)`
  margin: 61px 0 16px 0;
`;
